import SuspenseLoading from "components/loading";
import ThemeProvider from "contexts/theme/ThemeProvider";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import RouterList from "router";
import store, { persistor } from "state/store";
import AlertProvider from "../alert/AlertProvider";
import LoadingProvider from "../loading/LoadingProvider";

const AppProvider = () => {
  const queryClient = new QueryClient();

  return (
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <LoadingProvider>
              <AlertProvider>
                <PersistGate persistor={persistor}>
                  <Suspense fallback={<SuspenseLoading />}>
                    <RouterList />
                  </Suspense>
                </PersistGate>
              </AlertProvider>
            </LoadingProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
      <ToastContainer containerId={"A"} position={toast.POSITION.TOP_RIGHT} />
    </Provider>
  );
};

export default AppProvider;
